<template>
  <div>
    <b-overlay :show="show">
      <b-card title="Anwesenheit" class="m-3">
        <b-skeleton-wrapper :loading="show">
          <template #loading>
            <b-skeleton width="45%"></b-skeleton>
            <b-skeleton width="60%"></b-skeleton>
          </template>
          <b-card-text class="d-flex justify-content-left">
            <div>
              {{ attendanceAssignments.formattedDate }}<br>
              <div v-if="attendanceAssignments.description" style="color: #919191;font-size: 0.8em;">{{ attendanceAssignments.description }}</div>
            </div>
          </b-card-text>
        </b-skeleton-wrapper>

        <hr />

        <b-button-group style="width: 100%">
          <b-button
            :variant="presentVariant"
            @click="handleAssignment('present')"
            ><b-icon icon="check-circle"></b-icon
          ></b-button>
          <b-button :variant="absentVariant" @click="handleAssignment('absent')"
            ><b-icon icon="x-circle"></b-icon
          ></b-button>
        </b-button-group>

        <div
          v-if="
            (this.attendanceAssignments.currentUserAttendance === 'present' &&
            checkValidNeedLunch()) && 
            this.attendanceAssignments.activeNeedLunch === true
          "
        >
          <hr />
          <div
            class="d-flex justify-content-between"
            style="align-items: center"
          >
            <h4 style="display: contents">Mittagessen?</h4>
            <button
              class="btn"
              :class="isEatingToday ? 'btn-success' : 'btn-danger'"
              @click="handleNeedLunch"
            >
              <i :class="isEatingToday ? 'bi-check-circle' : 'bi-x-circle'"></i>
              {{ isEatingToday ? "Ja" : "Nein" }}
            </button>
          </div>
          <div v-if="days > 0" class="mt-1">
            <small>noch {{ days }} Tage {{ hours }} Stunden</small>
          </div>
          <div v-else-if="hours > 0 && minutes > 0" class="mt-1">
            <small>noch {{ hours }} Stunden {{ minutes }} Minuten</small>
          </div>
        </div>
        <div v-else-if="this.attendanceAssignments.currentUserAttendance === 'present' && this.attendanceAssignments.activeNeedLunch === true">
          <hr />
          <small>Frist zur Abstimmung für Mittagessen ist abgelaufen.</small>
        </div>
      </b-card>

      <b-card
        v-if="attendanceAssignments.users"
        title="Teilnehmerliste"
        class="m-3"
      >
        <b-card-text>
          <b-icon icon="check-circle"></b-icon>
          {{ attendanceAssignments.presentCount }} nehmen teil <br>
          <b-icon icon="x-circle"></b-icon>
          {{ attendanceAssignments.absentCount }} haben abgesagt
        </b-card-text>

        <hr />

        <ul style="text-align: left; list-style-type:none;">
          <li
            v-for="(assignment, index) in attendanceAssignments.users"
            :key="index"
          >
            <div v-if="assignment.attendance === 'present'">
              <b-icon icon="check-circle" variant="success"></b-icon> {{ assignment.user }} <span v-if="assignment.needLunch">
                & Mittagessen</span
              > 
            </div>
            <div v-if="assignment.attendance === 'absent'">
              <b-icon icon="x-circle" variant="danger"></b-icon> {{ assignment.user }}
            </div>
          </li>
        </ul>
      </b-card>
      <b-card v-else title="Teilnehmerliste" class="m-3">
        <b-alert show variant="warning" class="mt-4"
          >Keine Daten vorhanden</b-alert
        >
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "attendanceShowContainer",
  components: {},
  props: {
    date: String,
  },
  data() {
    return {
      show: false,

      attendanceAssignments: [],

      isEatingToday: false,

      timeRemaining: 0,
      days: 0,
      hours: 0,
      minutes: 0,

      apiUrl: process.env.VUE_APP_API_URL,
    };
  },

  methods: {
    async handleNeedLunch() {
      const isEating = !this.isEatingToday;

      this.show = true;

      const body = {
        attendanceDay: this.attendanceAssignments.attendanceDayId,
        needLunch: isEating,
      };

      await axios
        .post(this.apiUrl + "/attendance/post-need-lunch", body)
        .then((response) => {
          this.show = false;
          console.log(response.data);
        });

      await this.fetchAttendace();
      await this.fetchNeedLunch();
    },

    async handleAssignment(assignment) {
      this.show = true;

      const body = {
        attendanceDay: this.attendanceAssignments.attendanceDayId,
        attendance: assignment,
      };

      await axios
        .post(this.apiUrl + "/attendance/post-assignment", body)
        .then((response) => {
          this.show = false;
          console.log(response.data);
        });

      await this.fetchAttendace();
    },

    async fetchAttendace() {
      this.show = true;
      axios
        .get(this.apiUrl + "/attendance/get-assignments?date=" + this.date)
        .then((response) => {
          this.show = false;
          this.attendanceAssignments = response.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },

    async fetchNeedLunch() {
      this.show = true;
      axios
        .get(this.apiUrl + "/attendance/get-need-lunch?date=" + this.date)
        .then((response) => {
          this.show = false;
          this.isEatingToday = response.data.needLunch;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },

    checkValidNeedLunch() {
      let assignmentDate = new Date(this.date);
      let deadlineDate = new Date(assignmentDate);

      deadlineDate.setDate(assignmentDate.getDate() - 1);

      let currentDate = new Date();

      if (currentDate.getTime() < deadlineDate.getTime()) {
        return true;
      } else {
        return false;
      }
    },

    startCountdown() {
      let assignmentDate = new Date(this.date);
      let deadlineDate = new Date(assignmentDate);

      deadlineDate.setDate(assignmentDate.getDate() - 1);

      this.timeRemaining = deadlineDate - new Date().getTime();

      if (this.timeRemaining <= 0) {
        clearInterval(this.startCountdown);
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
      } else {
        this.days = Math.floor(this.timeRemaining / (1000 * 60 * 60 * 24));
        this.hours = Math.floor(
          (this.timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        this.minutes = Math.floor(
          (this.timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
        );
      }
    },
  },

  computed: {
    presentVariant() {
      return this.attendanceAssignments.currentUserAttendance === "present"
        ? "success"
        : "outline-success";
    },

    absentVariant() {
      return this.attendanceAssignments.currentUserAttendance === "absent"
        ? "danger"
        : "outline-danger";
    },
  },

  async beforeMount() {
    this.startCountdown();
    await this.fetchAttendace();
    await this.fetchNeedLunch();
  }
};
</script>

<style scoped>
small {
  display: block;
  color: #919191;
  font-size: 0.8em;
}


.present-badge {
  background-color: #e8ffdd;
  color: #21a600;
  padding: 4px 10px;
  font-size: 0.8rem;
  font-weight: bold;
  border-radius: 12px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  display: inline-block;
}
.absent-badge {
  background-color: #ffdddd;
  color: #a60000;
  padding: 4px 10px;
  font-size: 0.8rem;
  font-weight: bold;
  border-radius: 12px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  display: inline-block;
}
</style>
